/** @format */

import { createSlice } from "@reduxjs/toolkit";
import { preparePaginationData } from "../constant/common";
import {
  deleteOrder,
  getAllOrders,
  getOrderDetailes,
  updateOrder,
} from "../services/dashboard";
import { DateFormatter } from "../utilities/helper";

const initialState = {
  orders: {},
  loading: false,
  success: true,
  error: null,
  orderDetailes: {},
};

//login service

const orders = createSlice({
  name: "orders",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getAllOrders.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(getAllOrders.fulfilled, (state, action) => {
      let data = preparePaginationData(action.payload.data);
      data.data = data.data.map((item) => ({
        ...item,
        name: item.user.name,
        serviceName: item.service.name_ar,
      }));
      state.loading = false;
      state.orders = data;
      state.success = action.payload.data.success;
    });
    builder.addCase(getAllOrders.rejected, (state, action) => {
      state.loading = false;
      state.success = action.payload.response.data.success;
      state.error = action.payload.response.data.error;
    });
    builder.addCase(getOrderDetailes.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(getOrderDetailes.fulfilled, (state, action) => {
      let data = action.payload.data;
      data = {
        ...data,
        name: data.user?.name,
        serviceName: data.service?.name_ar,
        totall: data.total.toString() + " " + "د.ك",
        created_at: DateFormatter(data.created_at),
      };
      state.loading = false;
      state.orderDetailes = data;
      state.success = action.payload.data.success;
    });
    builder.addCase(deleteOrder.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(deleteOrder.fulfilled, (state, action) => {
      state.loading = false;
      state.success = action.payload.data?.success;
    });
    builder.addCase(deleteOrder.rejected, (state, action) => {
      state.loading = false;
      state.success = action.payload.response.data.success;
      state.error = action.payload.response.data.error;
    });
    builder.addCase(updateOrder.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(updateOrder.fulfilled, (state, action) => {
      state.loading = false;
      state.success = action.payload.data?.success;
    });
    builder.addCase(updateOrder.rejected, (state, action) => {
      state.loading = false;
      state.success = action.payload.response.data?.success;
      state.error = action.payload.response.data?.error;
    });
  },
});
export default orders.reducer;
